import { store as canvasDesignStore } from '../../store/canvasDesignStore';

export const prepareVariables = async ({ information, variableType, modules, moduleId, activityId }) => {
  let informationPart = [];

  if (Array.isArray(information)) {
    informationPart = information.map((x) => {
      let moduleName = "";
      if (x.connectionId) {
        const module = Array.isArray(modules) ?
          modules.find((y) => y.id == x.connectionId.toString()) :
          null;
        if (module) {
          moduleName = module.name;
        } else {
          moduleName = x.connection;
        }
      }

      return {
        fieldName: x.fieldName,
        type: x.type,
        name: x.displayName,
        fields: x.fields,
        moduleId: x.connectionId ? x.connectionId.toString() : null,
        moduleName: moduleName,
        referenceModuleId: x.referenceModuleId,
        referenceModuleTableId: x.referenceModuleTableId
      };
    });
  }

  let systemPart = [
    {
      fieldName: "documentId",
      name: "Document ID",
      system: true,
      type: 0
    },
    {
      fieldName: "createdBy",
      name: "Created By",
      system: true,
      type: 0
    },
    {
      fieldName: "createdDate",
      name: "Created Date",
      system: true,
      type: 5
    },
    {
      fieldName: "lastChangeBy",
      name: "Last Change By",
      system: true,
      type: 0
    },
    {
      fieldName: "lastChangeDate",
      name: "Last Change Date",
      system: true,
      type: 5
    },
    {
      fieldName: "state",
      name: "State",
      system: true,
      type: 5
    }
  ];

  let constants = [
    // {
    //     fieldName: 'today',
    //     name: 'Today',
    //     constant: true,
    // },
    // {
    //     fieldName: 'tomorrow',
    //     name: 'Tomorrow',
    //     constant: true,
    // }
  ];

  let aggregation = [
    {
      fieldName: "sum",
      name: "Sum",
      function: true
    },
    {
      fieldName: "find",
      name: "Find",
      function: true
    },
    {
      fieldName: "filter",
      name: "Filter",
      function: true
    },
    {
      fieldName: "sort",
      name: "Sort",
      function: true
    }
  ];

  // if (variableType == 14) {
  //   return [...aggregation];
  // }

  if (variableType == 36 || variableType == 14) {
    return [...informationPart];
  }

  if (
    ['createEditView', 'create', 'edit'].indexOf(activityId) > -1 &&
    moduleId && 
    Array.isArray(modules) && 
    !informationPart.some((x) => x.fieldName === 'username')
  ) {
    // const module = modules.find((x) => x.id == moduleId);
    const module = await canvasDesignStore.dispatch("findVariable", { moduleId: moduleId });
    if (module && module.isUserCollection) {
      systemPart = [
        ...systemPart,
        { id: 'username', name: 'Username', fieldName: 'username', system: true, type: 19 }
      ];
    }
  }

  return [...systemPart, ...informationPart, ...constants];
}

export const filterInformation = (information) =>
  Array.isArray(information) && information.filter((x) =>
    ["description", "image", "empty", "button"].indexOf(x.input) === -1
  );

export const findLastFormulaUnit = (rangeStart) => {
  if (rangeStart && rangeStart.data && rangeStart.data.indexOf("#") == 0) {
    let breaker = 0;
    let primer = rangeStart.previousSibling;

    while (breaker < 4) {
      if (primer && primer.tagName == "FTS-I-UNIT") {
        return primer;
      } else if (!primer) {
        return null;
      }

      primer = primer.previousSibling;
      breaker++;
    }

    return null;
  }
}